import {Form, Input, message, Modal, Select} from "antd";
import {useEffect, useState} from "react";
import {HttpService} from "../../../services/http/Http.service";
import {BasicDocumentDto} from "../../../model/models";
import {HttpErrorService} from "../../../services/http/HttpError.service";
import ReactQuill from "react-quill";

interface Props {
    visible: boolean,
    onClose: () => void,
    email: string
}

export default function SendModulesModal({visible, onClose, email}: Props) {
    const [emailForm] = Form.useForm();
    const [modules, setModules] = useState<BasicDocumentDto[]>([]);
    const [loadingModules, setLoadingModules] = useState(false);

    useEffect(() => {
        if (visible) {
            fetchModules();
        }
    }, [visible]);

    const fetchModules = async () => {
        setLoadingModules(true);
        try {
            const data = await HttpService.getInstanceAxios().get("/document/allModules")
            setModules(data.data);
        } catch (error) {
            HttpErrorService.handle("Errore durante il recupero dei moduli", error, true)
        } finally {
            setLoadingModules(false)
        }
    };

    const handleModuleChange = (moduleId: number) => {
        const selected = modules.find((mod) => mod.id === moduleId);
        if (selected) {
            emailForm.setFieldsValue({
                object: selected.emailSubject || "",
                text: selected.emailBody || "",
            });
        }
    };

    const sendEmail = async () => {
        emailForm.validateFields().then(() => {
                emailForm.resetFields();
                onClose();
            })
            .catch((info) => {
                console.log("Errore di validazione:", info);
            });
        const values = emailForm.getFieldsValue();
        const requestBody = {
            emailAddress: values.email,
            subject: values.object,
            body: normalizeQuillHtml(values.text)
        }
        try {
            await HttpService.getInstanceAxios().post(`/document/module/${values.attachments}/send`, requestBody)
            message.success("Mail inviata con successo")
        } catch (error) {
            HttpErrorService.handle("Errore durante l'invio della mail", error, true)
        }
    }

    const normalizeQuillHtml = (html: string) => {
        return html.replace(/<p>/g, '<p style="margin:0;padding:0;">');
    };

    return (
        <Modal
            title="Invio moduli"
            open={visible}
            onCancel={() => {
                emailForm.resetFields();
                onClose();
            }}
            okText="Invia email"
            onOk={sendEmail}
            maskClosable={false}
        >
            <Form
                form={emailForm}
                layout="vertical"
            >
                <Form.Item
                    label="Allegati"
                    name="attachments"
                    rules={[{required: true, message: "Seleziona un modulo!"}]}
                >
                    <Select
                        loading={loadingModules}
                        placeholder="Seleziona un modulo"
                        options={modules.map((mod) => ({
                            value: mod.id,
                            label: mod.name,
                        }))}
                        onChange={handleModuleChange}
                    />
                </Form.Item>

                <Form.Item
                    label="Email destinatario"
                    name="email"
                    rules={[
                        {required: true, message: "Inserisci l'email!"},
                        {type: "email", message: "Inserisci un'email valida!"},
                    ]}
                    initialValue={email}
                >
                    <Input placeholder="Email destinatario"/>
                </Form.Item>

                <Form.Item
                    label="Oggetto"
                    name="object"
                    rules={[{required: true, message: "Inserisci l'oggetto!"}]}
                >
                    <Input placeholder="Oggetto email"/>
                </Form.Item>

                <Form.Item
                    label="Testo"
                    name="text"
                    rules={[{ required: true, message: "Inserisci il testo dell'email!" }]}
                >
                    <ReactQuill
                        theme="snow"
                        onChange={(value) => {
                            emailForm.setFieldsValue({ text: value });
                        }}
                    />
                </Form.Item>

            </Form>
        </Modal>
    );
}
